import { authAxios } from "../api/axiosClient";
import { listCategory } from "../constants";

export const GetListCategory = (params = {}) => {
  const url = listCategory;
  return authAxios().get(url, { params });
};
